import { createClient } from '@supabase/supabase-js';
import cookieStorageAdapter, { migrateLocalStorageToCookie } from './cookieStorageAdapter';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase configuration is missing. Check REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.');
}

// Clé de stockage Supabase (utilisée pour la migration localStorage → cookie)
const getSupabaseStorageKey = () => {
  try {
    if (!supabaseUrl) return 'sb-auth-token';
    const hostname = new URL(supabaseUrl).hostname;
    const projectRef = hostname.split('.')[0];
    return projectRef ? `sb-${projectRef}-auth-token` : 'sb-auth-token';
  } catch {
    return 'sb-auth-token';
  }
};

// Migration automatique : localStorage → cookie (une seule fois)
if (typeof window !== 'undefined' && supabaseUrl) {
  migrateLocalStorageToCookie(getSupabaseStorageKey());
}

// Options du client Supabase pour une persistance fiable via cookie
const supabaseOptions = {
  auth: {
    // Persister la session via cookie (expiration 12 mois)
    persistSession: true,
    // Cookie storage adapter : cookie fonctionnel, pas de consentement RGPD requis
    storage: typeof window !== 'undefined' ? cookieStorageAdapter : undefined,
    // Rafraîchir automatiquement les tokens avant expiration
    autoRefreshToken: true,
    // Détecter automatiquement les changements de session dans d'autres onglets
    detectSessionInUrl: true,
  },
};

// Créer le client Supabase seulement si les variables sont définies
// Sinon, créer un mock qui ne bloque pas l'app
export const supabase = (supabaseUrl && supabaseAnonKey)
  ? createClient(supabaseUrl, supabaseAnonKey, supabaseOptions)
  : {
      auth: {
        getSession: async () => ({ data: { session: null }, error: null }),
        onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
        signUp: async () => ({ data: null, error: new Error('Supabase not configured') }),
        signInWithPassword: async () => ({ data: null, error: new Error('Supabase not configured') }),
        signOut: async () => ({ error: null }),
      },
      from: () => ({
        select: () => ({ eq: () => ({ maybeSingle: async () => ({ data: null, error: null }), single: async () => ({ data: null, error: null }) }) }),
        insert: () => ({ select: () => ({ single: async () => ({ data: null, error: null }) }) }),
        update: () => ({ eq: () => ({ select: () => ({ maybeSingle: async () => ({ data: null, error: null }) }) }) }),
      }),
    };
